import { btnCancel, btnOne, modalContainer, modalTitle } from "../utils/style";
import warning from '../assets/icons/warning.png'


function ConfirmationModal({setShowForm, title, confirm}) {

    return(
        <div className={modalContainer}>
            <div className="bg-white w-1/3 px-8 pt-8 pb-4 rounded-lg">
                <div className={modalTitle}>{`Deactivate ${title}`}</div>
                <div className="flex gap-2 items-center py-6">
                    <img src={warning} height={25} width={25} />
                    <div className="text-center">{`Are you sure you want to deactivate ${title}?`}</div>
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={e => setShowForm(false)} className={btnCancel}>Cancel</button>
                    <button onClick={e => confirm()} className={btnOne}>Submit</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal;